import {map} from 'rxjs/operators';
/**
 * Created by christiancueni on 29/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Observable} from 'rxjs';
import * as reducer from "../reducers";
import {Store} from '@ngrx/store';

@Component({
  selector: 'hc-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="footer">
      <div class="footer__actions footer__section">
        <ul class="unstyled-list footer-list">
          <li class="footer-list__item">
            <a routerLink="/login">{{ 'Anmelden' | translate }}</a>
          </li>
          <li class="footer-list__item">
            <a data-cy="footer-signup" routerLink="/signup">{{ 'Registrieren' | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="footer__support footer__section">
        <ul class="unstyled-list footer-list">
          <li class="footer-list__item">
            <a href="https://helloclass.zendesk.com/hc/de">{{ 'Fragen und Antworten' | translate }}</a>
          </li>
          <li class="footer-list__item">
            <a
              href="https://helloclass.zendesk.com/hc/de/requests/new">{{ 'Support Anfrage einreichen' | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="footer__legal footer__section">
        <ul class="unstyled-list footer-list">
          <li class="footer-list__item">
            <a href="{{ (languageLinks$ | async)['privacy'] }}">{{ 'Datenschutz' | translate }}</a>
          </li>
          <li class="footer-list__item">
            <a href="{{ (languageLinks$ | async)['agb'] }}">{{ 'Rechtliches' | translate }}</a>
          </li>
          <li class="footer-list__item">
            <a href="{{ (languageLinks$ | async)['cookies'] }}">{{ 'Cookies' | translate }}</a>
          </li>
          <li class="footer-list__item">
            <a href="/imprint">{{ 'Impressum' | translate }}</a>
          </li>
        </ul>
      </div>
    </footer>
  `,
})
export class FooterComponent {

  public languageLinks$: Observable<Object>;

  constructor(private store: Store<reducer.AppState>) {
    this.languageLinks$ = store.select(reducer.getLanguage).pipe(
      map((language) => {

        switch (language) {
          case 'fr':
            return {
              cookies: '/assets/documents/FR_HelloClass_Cookies.pdf',
              agb: '/assets/documents/FR_HelloClass_Nutzungsbedingungen.pdf',
              privacy: '/assets/documents/FR_HelloClass_Privacy_Policy.pdf'
            };
          case 'it':
            return {
              cookies: '/assets/documents/IT_HelloClass_Cookies.pdf',
              agb: '/assets/documents/IT_HelloClass_Nutzungsbedingungen.pdf',
              privacy: '/assets/documents/IT_HelloClass_Privacy_Policy.pdf'
            };
          default:
            return {
              cookies: '/assets/documents/DE_HelloClass_Cookies.pdf',
              agb: '/assets/documents/DE_HelloClass_Nutzungsbedingungen.pdf',
              privacy: '/assets/documents/DE_HelloClass_Privacy_Policy.pdf'
            };
        }
      }));
  }
}
